import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=4777b208&"
import script from "./CreateButton.vue?vue&type=script&lang=ts&"
export * from "./CreateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports